// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table.comman-table > tbody > tr > td {
  padding: 0px 0px;
  text-align: center;
}

.table.comman-table > thead > tr > td {
  padding: 0px 0px;
  text-align: center;
}

.search5 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.overlaylist {
  width: 100%;
  height: 30vh;
  overflow: hidden;
  overflow-y: scroll;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlcG9ydC1ieS1jbGllbnQuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxnQkFBQTtFQUNBLGtCQUFBO0FBQ0o7O0FBRUE7RUFDSSxnQkFBQTtFQUNBLGtCQUFBO0FBQ0o7O0FBRUE7RUFDSSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxpQkFBQTtBQUNKOztBQUNBO0VBQ0ksV0FBQTtFQUNBLFlBQUE7RUFDQSxnQkFBQTtFQUNBLGtCQUFBO0FBRUoiLCJmaWxlIjoicmVwb3J0LWJ5LWNsaWVudC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi50YWJsZS5jb21tYW4tdGFibGUgPiB0Ym9keSA+IHRyID4gdGQge1xuICAgIHBhZGRpbmc6IDBweCAwcHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG4udGFibGUuY29tbWFuLXRhYmxlID4gdGhlYWQgPiB0ciA+IHRkIHtcbiAgICBwYWRkaW5nOiAwcHggMHB4O1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxuLnNlYXJjaDV7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgIGZsZXgtd3JhcDogbm93cmFwO1xufVxuLm92ZXJsYXlsaXN0e1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMzB2aDtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIG92ZXJmbG93LXk6IHNjcm9sbDtcbn1cblxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/pages/medical/client-report/report-by-client/report-by-client.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAEJ;AACA,o8BAAo8B","sourcesContent":[".table.comman-table > tbody > tr > td {\n    padding: 0px 0px;\n    text-align: center;\n}\n\n.table.comman-table > thead > tr > td {\n    padding: 0px 0px;\n    text-align: center;\n}\n\n.search5{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n}\n.overlaylist{\n    width: 100%;\n    height: 30vh;\n    overflow: hidden;\n    overflow-y: scroll;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
